import actions from "./actions";

const updateError = actions.updateError;
const resetError = actions.resetError;

export default { updateError, resetError };
